export default function InformacoesDesclassificadas() {
    const hoje = new Date().toLocaleDateString('pt-BR');

    return (
        <div className="container mt-4">
            <p><small>Você está em <a href="/institucional">Institucional</a> / Informações Desclassificadas em Grau de Sigilo</small></p>
            <h1 className="mb-4">Informações Desclassificadas em Grau de Sigilo</h1>
            <p>2022 - Não foram desclassificadas informações sigilosas.</p>
            <p>2023 - Não foram desclassificadas informações sigilosas.</p>
            <p>2024 - Não foram desclassificadas informações sigilosas.</p>
            <p>2025 - Até o momento {hoje}, não foram desclassificadas informações sigilosas.</p>
        </div>
    );
}
